import logo from "../../assets/images/logo.svg";

import { Card } from "@material-tailwind/react";
import CardIcon from "../../assets/icons/card.svg";
import { useRef, useState } from "react";
import { useMutation } from "react-query";
import { SignUpForm } from "./authValidations";
import api from "../../services/apiService";
import ApiRoutes from "../../services/apiRoutes";
import { handleErrorMessage, isString } from "../../utility";
import {
  useOnboardingDetailsStore,
  useOnboardingStore,
  useRegisterStore,
} from "../../store/onboarding/Onboarding";
import { useNavigate } from "react-router-dom";
import ClickBaseButton from "../../components/common/buttons/ClickBaseButton";
import AuthService from "../../services/authService";
import { toast } from "react-toastify";

function RegistrationDocument() {
  const [boatOperatorLicense, setBoatOperatorLicense] = useState<File | null>(
    null
  );
  const boatOperatorLicenseRef = useRef<HTMLInputElement>(null);
  const [cacFile, setCacFile] = useState<File | null>(null);
  const cacInputRef = useRef<HTMLInputElement>(null);

  const updateBoatOperatorLicense = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files[0]) {
      setBoatOperatorLicense(event.target.files[0]);
    }
  };

  const updateCacFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setCacFile(event.target.files[0]);
    }
  };
  const navigation = useNavigate();
  const { setDetails } = useOnboardingDetailsStore();
  const { registerUser, clearUser } = useRegisterStore();
  const accountType = useOnboardingStore().accountType;
  const onSubmit = () => {
    if (boatOperatorLicense === null) {
      toast.error("Add Operator license Documents");
      return;
    }

    if (accountType === "cooperate" && cacFile === null) {
      toast.error("Add CAC Documents");
      return;
    }
    
    const businessData = {
      userType: 6,
      businessType: accountType === "cooperate" ? 2 : 1,
      serviceType: 2,
    };
    if (!isString(registerUser)) {
      navigation("/");
      return;
    }

    const data = AuthService.decryptUserData(registerUser as string);
    console.log(data);
    const newUser = { ...data!, ...businessData };

    signUpMutation.mutate(newUser);
  };
  const signUpMutation = useMutation(
    (data: SignUpForm) => {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
      });
      formData.append("BoatOperatorLicense", boatOperatorLicense!);
      formData.append("CAC", cacFile!);
      return api.post(ApiRoutes.register, formData);
    },
    {
      onSuccess: (_, variables) => {
        const { email, phoneNumber } = variables;
        setDetails({ email, phoneNumber });
        clearUser();
        navigation("/verifyEmail");
      },
      onError: (error) => {
        handleErrorMessage(
          error,
          "Unable to register user. Please try again later."
        );
      },
    }
  );

  const { isLoading } = signUpMutation;

  return (
    <div className="lg:flex w-screen md:h-screen bg-gray-50">
      <div className="invisible lg:visible bg-map-background bg-no-repeat w-3/6 relative flex flex-col justify-center items-center">
        <img
          className="  absolute md:top-10 md:left-20"
          src={logo}
          alt="GIGM Logo"
        />
        <div className="text-4xl">
          <h1>It’s easier to get</h1>
          <h2 className="inline">started with{` `}</h2>
          <h2 className="inline font-extrabold text-primary">GIGM Boat</h2>
        </div>
      </div>
      <img className="ml-20 md:hidden" src={logo} alt="GIGM Logo" />
      <div className="flex items-center justify-center ">
        <div className="md:w-[60%] md:m-24 m-10">
          <h2 className=" text-2xl text-center">Sign into your account</h2>
          <p className="text-center">
            Upload your license issued by the Lagos State Government
          </p>
          <Card placeholder={undefined} color="transparent" shadow={false}>
            <div className="mt-8 mb-2 w-80 max-w-screen-lg sm:w-96 my-auto ">
              <Card
                placeholder={undefined}
                className="text-center w-52 mx-auto rounded-md p-8 bg-gray-300 cursor-pointer"
                onClick={() => boatOperatorLicenseRef.current?.click()}
              >
                <input
                  type="file"
                  accept="image/*,.pdf"
                  hidden={true}
                  ref={boatOperatorLicenseRef}
                  onChange={updateBoatOperatorLicense}
                />
                <p className="text-[12px] font-bold">Boat Operator License</p>
                <img
                  src={CardIcon}
                  alt="card icon"
                  className="w-12 mx-auto mt-3"
                />

                {boatOperatorLicense === null ? (
                  <p className="text-blue-300 text-[12px] mt-2">
                    Click here to upload files
                  </p>
                ) : (
                  <p className="text-[12px] "> {boatOperatorLicense!.name}</p>
                )}
              </Card>
              <Card
                placeholder={undefined}
                className="text-center w-52 mx-auto rounded-md mt-5 p-8 bg-gray-300 cursor-pointer"
                onClick={() => cacInputRef.current?.click()}
              >
                <p className="text-[12px] font-bold">Business Document (CAC)</p>
                <input
                  type="file"
                  accept="image/*,.pdf"
                  hidden={true}
                  ref={cacInputRef}
                  onChange={updateCacFile}
                />
                <img
                  src={CardIcon}
                  alt="card icon"
                  className="w-12 mx-auto mt-3"
                />

                {cacFile === null ? (
                  <p className="text-blue-300 text-[12px] mt-2  ">
                    Click here to upload files
                  </p>
                ) : (
                  <p className="text-[12px] mt-2 text-center overflow-hidden">
                    {" "}
                    {cacFile!.name}
                  </p>
                )}
              </Card>

              <ClickBaseButton
                onClick={() => {
                  onSubmit();
                }}
                isLoading={isLoading}
              >
                GET STARTED
              </ClickBaseButton>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default RegistrationDocument;
